import { hubCards } from '@/mocks/homeData';

export default function EntryHub() {
  return (
    <section id="ru-kou" className="mx-auto max-w-6xl px-4 pb-14 md:px-6 md:pb-20">
      <div className="relative overflow-hidden rounded-2xl bg-primary-900 px-6 py-10 md:px-12 md:py-14">
        <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-primary-500/40 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-20 -left-10 h-56 w-56 rounded-full bg-accent-500/20 blur-3xl" />

        <div className="relative grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="flex flex-col justify-center lg:col-span-5">
            <span className="inline-flex w-fit items-center gap-2 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-foreground-950">
              <i className="ri-download-2-line" aria-hidden="true"></i>
              入站 · 协作 · 工具箱
            </span>
            <h2 className="mt-5 font-heading text-2xl font-black leading-snug text-background-50 md:text-4xl md:leading-tight">
              别让材料烂在手里，
              <br />
              让它进入该去的地方。
            </h2>
            <p className="mt-5 max-w-md text-[15px] leading-relaxed text-background-200/90">
              收材料、核材料、放材料，三条路都在这儿。你是提供者也好、同查者也好，都能找到对应的入口。
            </p>

            <div className="mt-8">
              <a
                href="#ru-kou"
                className="inline-flex h-12 items-center justify-center gap-2 rounded-md bg-accent-500 px-7 text-sm font-semibold text-foreground-950 whitespace-nowrap transition-colors duration-200 hover:bg-accent-400 cursor-pointer"
              >
                <i className="ri-upload-cloud-2-line text-lg" aria-hidden="true"></i>
                立即提交线索 / 材料
              </a>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 lg:col-span-7">
            {hubCards.map((c) => (
              <div
                key={c.title}
                className="flex flex-col rounded-lg bg-background-50 p-5 transition-transform duration-200 hover:-translate-y-1"
              >
                <div className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-700">
                  <i className={c.icon} aria-hidden="true"></i>
                </div>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{c.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
                <a
                  href="#ru-kou"
                  className="mt-5 flex h-10 items-center justify-center gap-1.5 rounded-md bg-foreground-950 text-sm text-background-50 whitespace-nowrap transition-colors duration-200 hover:bg-primary-600 cursor-pointer"
                >
                  {c.action}
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}